// istanbul ignore file
export enum DateRange {
  YESTERDAY = "yesterday",
  LAST_7_DAYS = "last7Days",
  LAST_14_DAYS = "last14Days",
  THIS_MONTH = "thisMonth",
  PREVIOUS_MONTH = "previousMonth",
  CUSTOM = "custom",
}

export enum RiskTypes {
  PC = "PC",
  SS = "SS",
  NR = "NR",
  HC = "HC",
  AE = "AE",
}

export enum ReviewType {
  PV = "PV",
  PTQ = "PTQ",
  PCO = "PCO",
}
